const ProductVariants = ({ variants, preOrder = false, defaultVariantId }) => ({
  variants: {},
  selectedVariantId: "",
  cartItemCount: 0,
  get selectedVariant() {
    return this.variants[this.selectedVariantId];
  },
  get preorderNotice() {
    return this.variants[this.selectedVariantId]?.preorder_notice ?? "";
  },
  get stockAlert() {
    return this.variants[this.selectedVariantId]?.stock_alert ?? "";
  },
  get selectedTrimOption() {
    return this.selectedVariant.options.Trim;
  },
  get availableColorVariantsForTrimOption() {
    const trim = this.selectedTrimOption;

    if (!trim) return [];

    const variants = Object.values(this.variants).filter(
      variant => variant.option.Trim === trim && !variant.is_end_of_life
    );
    return variants;
  },
  get inStockColorVariantsForTrimOption() {
    const trim = this.selectedTrimOption;

    if (!trim) return [];

    const variants = Object.values(this.variants).filter(variant => variant.option.Trim === trim && variant.available);
    return variants;
  },
  isColorAvailableForTrimOption(color) {
    const trim = this.selectedTrimOption;

    if (!trim) return true;

    const variant = Object.values(this.variants).find(
      variant => variant.options.Trim === trim && variant.options.Color === color
    );

    return !variant.is_end_of_life;
  },
  colorHasStockForTrimOption(color) {
    const trim = this.selectedTrimOption;

    if (!trim) return true;

    const variant = Object.values(this.variants).find(
      variant => variant.options.Trim === trim && variant.options.Color === color
    );

    return variant.available;
  },
  preorderEnabled: preOrder,
  didLoadPreProduct: false,
  init() {
    const queryParams = new URLSearchParams(window.location.search);
    const variant = queryParams.get("variant");

    const selectedVariant = defaultVariantId;
    this.variants = variants;

    const firstAvailableVariantId = Object.keys(this.variants).find(id => this.variants[id]?.available === true);
    const firstNotEOLVariantId = Object.keys(this.variants).find(id => this.variants[id]?.is_end_of_life === false);

    this.selectedVariantId =
      selectedVariant || variant || firstAvailableVariantId || firstNotEOLVariantId || Object.keys(this.variants)[0];

    document.addEventListener("variant:changed", event => {
      if (!Object.keys(this.variants).includes(String(event.detail.variant.id))) return;

      this.selectedVariantId = String(event.detail.variant.id);
    });

    window.addEventListener(
      "ppJustLaunched",
      () => {
        this.didLoadPreProduct = true;
      },
      false
    );

    document.addEventListener("cart:updated", event => {
      const cart = event.detail.cart;
      this.cartItemCount = cart.item_count;
    });

    window.addEventListener("message", message => {
      if (message.data?.event == "conversionbearupsell:add_to_cart") {
        const event = message.data?.data;
        const addedQuantity =
          event?.offers?.reduce((acc, offer) => {
            return acc + offer.quantity;
          }, 0) ?? 1;

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: {
                item_count: this.cartItemCount + addedQuantity
              }
            }
          })
        );
      }
    });
  }
});

export default ProductVariants;
